import { InputOutputLegacy } from "./InputOutputLegacy"
import { getInputOutputForStep, isValidFieldsData } from "../helpers/tableHelpers"
import { TagValue } from "./TagValue"
import { InputOutputTable } from "../../Table/InputOutputTable"

export const InputOutput = ({ data, title }: { data: unknown, title: string }) => {
  if (!isValidFieldsData(data)) {
    return (
      <InputOutputLegacy
        title={title}
        className="mb-4"
        subtitle={getInputOutputForStep(data)}
      />
    )
  }

  return (
    <div className="w-full mb-4">
      <TagValue className='mb-4' title={title} subtitle={''} />
      <InputOutputTable data={data} />
    </div>
  )
}
